import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-270dabb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增客服")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px"} }, "选择管理员：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "平台客服",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVisible(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: false
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'name' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(text.name), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'mobile' && text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(text.mobile), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createBlock(_component_a_popconfirm, {
              key: 2,
              title: "确定删除吗?",
              onConfirm: ($event: any) => (_ctx.onDel(record))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  danger: true,
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onConfirm"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: "新增客服",
      onOk: _ctx.addService,
      confirmLoading: _ctx.loading,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setVisible(false)))
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_a_select, {
          placeholder: "请选择",
          value: _ctx.adminId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.adminId) = $event)),
          style: {"width":"80%"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adminList, (item) => {
              return (_openBlock(), _createBlock(_component_a_select_option, {
                value: item.id + '',
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name) + " (" + _toDisplayString(_ctx.renderRoles(item)) + ") ", 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "confirmLoading"])
  ], 64))
}